const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const isAnalyticsEnabled =
  process.env.NODE_ENV === "production" && Boolean(MEASUREMENT_ID);

export const initAnalytics = () => {
  if (!isAnalyticsEnabled) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", MEASUREMENT_ID);
};

export const trackPageView = (path) => {
  if (!isAnalyticsEnabled || typeof window.gtag !== "function") return;

  window.gtag("config", MEASUREMENT_ID, { page_path: path });
};

export const trackEvent = (name, params = {}) => {
  if (!isAnalyticsEnabled || typeof window.gtag !== "function") return;

  window.gtag("event", name, params);
};
